// extracted by mini-css-extract-plugin
export default {"root":"FKpjJ","active":"vWfNv","visited":"XZKYY","tip":"jfHf7","content":"fpjQq","icon":"xcFqp","image":"BFCcg","price":"YKvja"};